<template>
  <div>
    <div class="table-title">
      <div class="subject">
        <p>Invoices</p>
        <span v-if="typeof paginate.total === 'number'">
          Total ({{paginate.total}})
        </span>
      </div>
    </div>

    <div class="table-head" v-if="isDesktop()">
      <p>Number</p>
      <p>Month</p>
      <p>Generated At</p>
      <p>Charges</p>
      <p>GST</p>
      <p class="d-l">Total Amount</p>
      <p></p>
    </div>

    <div class="table-body">
      <div class="table-row" v-for="(invoice, index) in list" :key="index">
        <p class="mt-grey-text">{{invoice.number}}</p>
        <p class="mt-right">{{invoice.for_month}}</p>
        <p class="mt-col-span2 mt-grey-text">
          <b v-if="!isDesktop()">Generated At:</b>
          {{invoice.generated_at}}
        </p>
        <p>
          <b v-if="!isDesktop()">Charges:</b>
          {{invoice.charges}}
        </p>
        <p class="mt-right">
          <b v-if="!isDesktop()">GST:</b>
          {{invoice.gst}}
        </p>
        <p class="mt-col-span2 d-l">
          <b v-if="!isDesktop()">Total Amount:</b>
          {{invoice.amount}}
        </p>
        <p v-if="invoice.status === 'COMPLETED'" class="download mt-col-span2"
              @click="download(invoice.id)">
          <i class="fa fa-download" v-if="!isDesktop()" />Download
        </p>
        <p v-else-if="isDesktop()"></p>
      </div>
    </div>

    <table-loader v-if="!paginate.data_added || list.length < paginate.total"
                  :css="{'single-side': !isDesktop()}" />

    <div class="table-empty" v-if="paginate.total === 0">
      <p>{{emptyRecords}}</p>
    </div>
  </div>
</template>

<script>
import ApiServices from '@/services/api/invoices'
import ListMixins from '@/mixins/listMixins'
import { amountFormat } from '@/utils/helpers'

export default {
  name: 'Invoices',
  mixins: [ListMixins],
  created () {
    this.populateParams()
    this.populateData()
  },
  methods: {
    amountFormat,
    populateParams () {
      this.paginate['type'] = 'Invoice'
    },
    fetchRecords (start) {
      return new Promise(resolve => {
        let params = {}
        if (start) {
          params['offset'] = start
        }

        ApiServices.invoicesList(params).then((response) => {
          let data = response.data
          if (data) {
            let invoices = data.invoices
            invoices = invoices.map(entry => {
              entry.charges = entry.charges ? this.amountFormat(entry.charges) : '-'
              entry.gst = entry.gst ? this.amountFormat(entry.gst) : '-'
              entry.amount = entry.amount ? this.amountFormat(entry.amount) : 'No charges this month'
              return entry
            })

            if (start) {
              this.list.push(...invoices)
            } else {
              this.list = invoices
              this.setPaginate(data)
            }
          }
          resolve()
        })
      })
    },
    download (id) {
      ApiServices.invoicesUrl(id).then((response) => {
        if (response.success) {
          location.href = response.data.download_url
        } else {
          this.errorToastMsg(response.message)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/table.scss';
</style>
